// src/types.ts

export interface WeatherData {
  air_temperature: number;
  dew_point: number;
  relative_humidity: number;
  time: string;
  wind_direction: string;
  wind_speed: number;
  is_daytime: boolean;
  icon: string;
  short_forecast: string;
}

export interface AlertData {
  message: string;
  time: string;
  type: string;
}

export interface AlertConfigData {
  days: number;
  threshold: number;
  type: string;
}

export interface AlertConfigRecord {
  id: string;
  data: AlertConfigData;
  icon?: any;
  text?: string;
  unit?: string;
}

export interface EmailData {
  id: string;
  data: {
    email: string;
  };
}

export interface TariffData {
  start_time_of_day: number;
  stop_time_of_day: number;
  tariff_rate: number;
}

export interface TariffRecord {
  id: string;
  data: TariffData;
}

export interface GasConsumptionData {
  gas_consumption: number;
  time: string;
}

export enum WeatherType {
  Sunny = 'Sunny',
  Cloudy = 'Cloudy',
  Rainy = 'Rainy',
}

export enum TrendsType {
  Hourly = 'hour',
  Days = 'day',
  Weeks = 'week',
  Months = 'month',
  Years = 'year',
}
